// Tide Post Landing Page Data

export const heroData = {
  headline: "Know Your Tides",
  subheadline:
    "Real-time tide predictions, water levels, and moon phases for every NOAA station in the United States",
  ctaPrimary: "Download Free",
  ctaSecondary: "Learn More",
  appStoreUrl: "https://apps.apple.com/us/app/tide-post/id6759380101",
};

export const featuresData = [
  {
    id: "tide-chart",
    icon: "chart",
    title: "Interactive Tide Chart",
    description:
      "View overlaid water level and prediction curves with an interactive timeline you can scrub through",
  },
  {
    id: "station-map",
    icon: "map",
    title: "NOAA Station Map",
    description:
      "Browse thousands of tidal stations across all U.S. coastlines with an interactive map interface",
  },
  {
    id: "tide-countdown",
    icon: "clock",
    title: "Next Tide Countdown",
    description:
      "See exactly how long until the next high or low tide with a live countdown timer",
  },
  {
    id: "water-level",
    icon: "water",
    title: "Real-Time Water Levels",
    description:
      "Current water level with rising or falling indicator updated from live NOAA measurements",
  },
  {
    id: "moon-phase",
    icon: "moon",
    title: "Moon Phase Display",
    description:
      "See the current moon phase, illumination percentage, and how it affects local tides",
  },
  {
    id: "tide-alerts",
    icon: "bell",
    title: "Tide Alerts",
    description:
      "Get notified 30 minutes, 1 hour, or 2 hours before high and low tides at your station",
  },
  {
    id: "forecast",
    icon: "calendar",
    title: "7-Day Forecast",
    description:
      "Plan ahead with a week-long forecast showing daily high and low tide times and heights",
  },
  {
    id: "favorites",
    icon: "star",
    title: "Favorite Stations",
    description:
      "Save your go-to stations for quick access and switch between them instantly",
  },
];

export const howItWorksData = [
  {
    step: 1,
    title: "Find Your Station",
    description:
      "Browse the interactive map or search by name to find any NOAA tidal station along U.S. coastlines",
    icon: "search",
  },
  {
    step: 2,
    title: "Check the Tides",
    description:
      "View real-time water levels, tide predictions, and countdown to the next high or low tide",
    icon: "chart",
  },
  {
    step: 3,
    title: "Stay Informed",
    description:
      "Set tide alerts, save favorite stations, and check the 7-day forecast before heading out",
    icon: "bell",
  },
];

export const faqData = [
  {
    id: "free",
    question: "Is Tide Post free?",
    answer:
      "Yes, Tide Post is completely free to download and use. All features including tide charts, station search, moon phases, and tide alerts are available at no cost. There are no in-app purchases, subscriptions, or ads.",
  },
  {
    id: "data-source",
    question: "Where does the tide data come from?",
    answer:
      "All tide data comes directly from NOAA (National Oceanic and Atmospheric Administration) Tides & Currents API. This is the same authoritative source used by the U.S. government for official tide predictions and water level measurements.",
  },
  {
    id: "accuracy",
    question: "How accurate are the predictions?",
    answer:
      "Tide predictions are generated by NOAA using harmonic analysis of historical data and are highly reliable for planning purposes. Real-time water levels are measured at 6-minute intervals directly from NOAA station sensors. Actual water levels may vary from predictions due to weather, wind, and atmospheric pressure.",
  },
  {
    id: "coverage",
    question: "Which locations are covered?",
    answer:
      "Tide Post covers all NOAA tidal stations across the United States, including the Atlantic coast, Pacific coast, Gulf of Mexico, Alaska, Hawaii, and U.S. territories. There are thousands of stations available.",
  },
  {
    id: "offline",
    question: "Does it work offline?",
    answer:
      "Tide Post requires an internet connection to fetch real-time water levels and predictions from NOAA. Your favorite stations and preferences are stored locally on your device and persist between sessions.",
  },
  {
    id: "privacy",
    question: "Is my data private?",
    answer:
      "Absolutely. Tide Post does not collect any personal information. There is no account system, no sign-in, and no tracking. All your preferences and favorite stations are stored locally on your device. The only network requests are to the public NOAA API to fetch tide data.",
  },
  {
    id: "devices",
    question: "What devices are supported?",
    answer:
      "Tide Post is available for iPhone running iOS 17.0 or later. The app is optimized for all iPhone screen sizes and supports Dynamic Type for accessibility.",
  },
  {
    id: "units",
    question: "Can I switch between feet and meters?",
    answer:
      "Yes. Tide Post supports both Imperial (feet) and Metric (meters) units. You can switch between them at any time in the Settings tab.",
  },
];

export const ctaData = {
  headline: "Ready to Know Your Tides?",
  subheadline:
    "Free to download. No account required. No ads. Just accurate tide data from NOAA.",
  cta: "Download on the App Store",
  appStoreUrl: "https://apps.apple.com/us/app/tide-post/id6759380101",
};

export const navigationLinks = [
  { id: "features", label: "Features" },
  { id: "how-it-works", label: "How It Works" },
  { id: "faq", label: "FAQ" },
];
